import { createSlice } from '@reduxjs/toolkit'

export const eduPortalManagement = createSlice({
  name: 'eduPortalManagement',
  initialState: {
    step: 'table',
    autoApprove:true,
    formName:'',
    formType:'',
    loginWithONEID:false,
    loginWithIDP:false,
    retrieve:[],
    active:true,
    portal:'',
    loginmethod:[],
    idp:[],
    editloginmethod:[],
    link:null,
    token:null,
    clientIDList:[],
    openTheme:false,
    portalthemename:'',
    portallogo:null,
    portalthemeprimecolor:{},
    portalthemesecondcolor:{},
    slidepage:1,
    primecolorpickeropen:false,
    secondcolorpickeropen:false,
    canclecreateportalmodal:false,
    canclecreatethemeportalmodal:false,
    deletemodal:false,
    valueautoapprove:'',
    acceptcreateportalmodal:false,
    switchactiveportal:false,
    base64portallogo:'',
    redirect_url:'',
    client_id:'',
    azureurl:'',
    googleurl:'',
    facebookurl:'',
    onecollaburl:''
  },
  reducers: {  
    setStepRedux: (state, action) => {
      const { step } = action.payload
      state.step = step
    },
    setAutoApproveRedux: (state, action) => {
      const { autoApprove } = action.payload
      state.autoApprove = autoApprove
    },
    setFormNameRedux: (state, action) => {
      const { formName } = action.payload
      state.formName = formName
    },
    setFormTypeRedux: (state, action) => {
      const { formType } = action.payload
      state.formType = formType
    },
    setLoginWithONEIDRedux: (state, action) => {
      const { loginWithONEID } = action.payload
      state.loginWithONEID = loginWithONEID
    },    
    setLoginWithIDPRedux: (state, action) => {
      const { loginWithIDP } = action.payload
      state.loginWithIDP = loginWithIDP
    },
    setRetrieveRedux: (state, action) => {
      const { retrieve } = action.payload
      state.retrieve = retrieve
    },     
    setActiveRedux: (state, action) => {
      const { active } = action.payload
      state.active = active
    }, 
    setPortalRedux: (state, action) => {
      const { portal } = action.payload
      state.portal = portal
    },
    setLoginMethodRedux: (state, action) => {
      const { loginmethod } = action.payload
      state.loginmethod = loginmethod
    },
    setIDPRedux: (state, action) => {
      const { idp } = action.payload
      state.idp = idp
    },
    setEditLoginMethodRedux: (state, action) => {
      const { editloginmethod } = action.payload
      state.editloginmethod = editloginmethod
    },
    setLinkRedux: (state, action) => {
      const { link } = action.payload
      state.link = link
    },   
    setTokenRedux: (state, action) => {
      const { token } = action.payload
      state.token = token
    }, 
    setClientIDListRedux: (state, action) => {
      const { clientIDList } = action.payload
      state.clientIDList = clientIDList
    },
    setOpenThemeRedux: (state, action) => {
      const { openTheme } = action.payload
      state.openTheme = openTheme
    },
    setPortalThemeNameRedux: (state, action) => {
      const { portalthemename } = action.payload
      state.portalthemename = portalthemename
    },   
    setPortalLogoRedux: (state, action) => {
      const { portallogo } = action.payload
      state.portallogo = portallogo
    },   
    setPortalThemePrimeColorRedux: (state, action) => {
      const { portalthemeprimecolor } = action.payload
      state.portalthemeprimecolor = portalthemeprimecolor
    },   
    setPortalThemeSecondColorRedux: (state, action) => {
      const { portalthemesecondcolor } = action.payload
      state.portalthemesecondcolor = portalthemesecondcolor
    },
    setSlidePageRedux: (state, action) => {
      const { slidepage } = action.payload
      state.slidepage = slidepage
    }, 
    setPrimeColorPickerOpenRedux: (state, action) => {
      const { primecolorpickeropen } = action.payload
      state.primecolorpickeropen = primecolorpickeropen
    },
    setSecondColorPickerOpenRedux: (state, action) => {
      const { secondcolorpickeropen } = action.payload
      state.secondcolorpickeropen = secondcolorpickeropen
    }, 
    setCancleCreatePortalModalRedux: (state, action) => {
      const { canclecreateportalmodal } = action.payload
      state.canclecreateportalmodal = canclecreateportalmodal
    },
    setCancleCreateThemePortalModalRedux: (state, action) => {
      const { canclecreatethemeportalmodal } = action.payload
      state.canclecreatethemeportalmodal = canclecreatethemeportalmodal
    },   
    setDeleteModalRedux: (state, action) => {
      const { deletemodal } = action.payload
      state.deletemodal = deletemodal
    }, 
    setValueAutoApproveRedux: (state, action) => {
      const { valueautoapprove } = action.payload
      state.valueautoapprove = valueautoapprove
    },
    setSearchTextRedux: (state, action) => {
      const { searchtext } = action.payload
      state.searchtext = searchtext
    }, 
    setAcceptCreatePortalModalRedux: (state, action) => {
      const { acceptcreateportalmodal } = action.payload
      state.acceptcreateportalmodal = acceptcreateportalmodal
    },
    setSwitchActivePortalRedux: (state, action) => {
      const { switchactiveportal } = action.payload
      state.switchactiveportal = switchactiveportal
    },  
    setBase64PortalLogoRedux: (state, action) => {
      const { base64portallogo } = action.payload
      state.base64portallogo = base64portallogo
    },
    setRedirectURLRedux: (state, action) => {
      const { redirect_url } = action.payload
      state.redirect_url = redirect_url
    },  
    setClientIDRedux: (state, action) => {
      const { client_id } = action.payload
      state.client_id = client_id
    },  
    setAzureURLRedux: (state, action) => {
      const { azureurl } = action.payload
      state.azureurl = azureurl
    },    
    setGoogleURLRedux: (state, action) => {
      const { googleurl } = action.payload
      state.googleurl = googleurl
    },    
    setFacebookURLRedux: (state, action) => {
      const { facebookurl } = action.payload
      state.facebookurl = facebookurl
    },          
    setOneCollabURLRedux: (state, action) => {
      const { onecollaburl } = action.payload
      state.onecollaburl = onecollaburl
    },
  },
})

export default eduPortalManagement.reducer;

export const {
  setStepRedux,
  setAutoApproveRedux,
  setFormNameRedux,
  setFormTypeRedux,
  setLoginWithONEIDRedux,
  setLoginWithIDPRedux,
  setRetrieveRedux,
  setActiveRedux,
  setPortalRedux,
  setLoginMethodRedux,
  setIDPRedux,
  setEditLoginMethodRedux,
  setLinkRedux,
  setTokenRedux,
  setClientIDListRedux,
  setOpenThemeRedux,
  setPortalThemeNameRedux,
  setPortalLogoRedux,
  setPortalThemePrimeColorRedux,
  setPortalThemeSecondColorRedux,
  setSlidePageRedux,
  setPrimeColorPickerOpenRedux,
  setSecondColorPickerOpenRedux,
  setCancleCreatePortalModalRedux,
  setCancleCreateThemePortalModalRedux,
  setDeleteModalRedux,
  setValueAutoApproveRedux,
  setSearchTextRedux,
  setAcceptCreatePortalModalRedux,
  setSwitchActivePortalRedux,
  setBase64PortalLogoRedux,
  setRedirectURLRedux,
  setClientIDRedux,
  setAzureURLRedux,
  setGoogleURLRedux,
  setFacebookURLRedux,
  setOneCollabURLRedux
} = eduPortalManagement.actions

export const getStepRedux = (state) => state.eduPortalManagement.step
export const getAutoApproveRedux = (state) => state.eduPortalManagement.autoApprove
export const getFormNameRedux = (state) => state.eduPortalManagement.formName
export const getFormTypeRedux = (state) => state.eduPortalManagement.formType
export const getLoginWithONEIDRedux = (state) => state.eduPortalManagement.loginWithONEID
export const getLoginWithIDPRedux = (state) => state.eduPortalManagement.loginWithIDP
export const getRetrieveRedux = (state) => state.eduPortalManagement.retrieve
export const getActiveRedux = (state) => state.eduPortalManagement.active
export const getPortalRedux = (state) => state.eduPortalManagement.portal
export const getLoginMethodRedux = (state) => state.eduPortalManagement.loginmethod
export const getIDPRedux = (state) => state.eduPortalManagement.idp
export const getEditLoginMethodRedux = (state) => state.eduPortalManagement.editloginmethod
export const getTokenRedux = (state) => state.eduPortalManagement.token
export const getLinkRedux = (state) => state.eduPortalManagement.link
export const getClientIDListRedux = (state) => state.eduPortalManagement.clientIDList
export const getOpenThemeRedux = (state) => state.eduPortalManagement.openTheme
export const getPortalThemeNameRedux = (state) => state.eduPortalManagement.portalthemename
export const getPortalLogoRedux = (state) => state.eduPortalManagement.portallogo
export const getPortalThemePrimeColorRedux = (state) => state.eduPortalManagement.portalthemeprimecolor
export const getPortalThemeSecondColorRedux = (state) => state.eduPortalManagement.portalthemesecondcolor
export const getSlidePageRedux = (state) => state.eduPortalManagement.slidepage
export const getPrimeColorPickerOpenRedux = (state) => state.eduPortalManagement.primecolorpickeropen
export const getSecondColorPickerOpenRedux = (state) => state.eduPortalManagement.secondcolorpickeropen
export const getCancleCreatePortalModalRedux = (state) => state.eduPortalManagement.canclecreateportalmodal
export const getCancleCreateThemePortalModalRedux = (state) => state.eduPortalManagement.canclecreatethemeportalmodal
export const getDeleteModalRedux = (state) => state.eduPortalManagement.deletemodal
export const getValueAutoApproveRedux = (state) => state.eduPortalManagement.valueautoapprove
export const getSearchTextRedux = (state) => state.eduPortalManagement.searchtext
export const getAcceptCreatePortalModalRedux = (state) => state.eduPortalManagement.acceptcreateportalmodal
export const getSwitchActivePortalRedux = (state) => state.eduPortalManagement.switchactiveportal
export const getBase64PortalLogoRedux = (state) => state.eduPortalManagement.base64portallogo
export const getRedirectURLRedux = (state) => state.eduPortalManagement.redirect_url
export const getClientIDRedux = (state) => state.eduPortalManagement.client_id
export const getAzureURLRedux = (state) => state.eduPortalManagement.azureurl
export const getGoogleURLRedux = (state) => state.eduPortalManagement.googleurl
export const getFacebookURLRedux = (state) => state.eduPortalManagement.facebookurl
export const getOneCollabURLRedux = (state) => state.eduPortalManagement.onecollaburl



















